module.exports = __webpack_public_path__ + "img/Chien Tu.45d02df7.svg";